import { getOrder } from 'api/jalapeno';

export default async function loader({ params }) {
    try {
        const orderDetailsData = await getOrder(params.id);
        return orderDetailsData;
    } catch (error) {
        return error;
    }
}
